<h2 mat-dialog-title>{{ isEdit ? "Editar producto" : "Nuevo producto" }}</h2>

<mat-dialog-content [formGroup]="form" class="product-dialog-content">
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Nombre</mat-label>
    <input matInput formControlName="name" maxlength="120" />
    <mat-error *ngIf="form.get('name')?.hasError('required')">
      El nombre es obligatorio
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Descripción</mat-label>
    <textarea matInput formControlName="description" rows="3"></textarea>
  </mat-form-field>

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Precio</mat-label>
    <input matInput formControlName="price" placeholder="Ej: $25.000" />
  </mat-form-field>

  <div class="images-block">
    <div class="images-header">
      <span>Imágenes</span>
      <button
        mat-stroked-button
        type="button"
        (click)="fileInput.click()"
        [disabled]="uploading"
      >
        <mat-icon>add_photo_alternate</mat-icon>
        Agregar
      </button>
      <input
        #fileInput
        type="file"
        accept="image/*"
        multiple
        hidden
        (change)="onFilesSelected($event)"
      />
    </div>

    <mat-progress-bar *ngIf="uploading" mode="indeterminate"></mat-progress-bar>

    <div class="thumbs" *ngIf="images.length > 0">
      <div class="thumb" *ngFor="let img of images; let i = index">
        <img [src]="img" alt="producto" />
        <button
          mat-icon-button
          class="thumb-remove"
          type="button"
          (click)="removeImage(i)"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <p class="no-images" *ngIf="images.length === 0 && !uploading">
      Sin imágenes.
    </p>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()" [disabled]="saving">
    Cancelar
  </button>
  <button
    mat-flat-button
    class="default-btn bg-color-blue-button"
    type="button"
    (click)="save()"
    [disabled]="saving || uploading"
  >
    {{ saving ? "Guardando..." : "Guardar" }}
  </button>
</mat-dialog-actions>
